import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IMavenirConfig,
	IMavenirConfigCheck,
	IMavenirConfigTree,
	IMavenirConfigUploadUrl,
	TMavenirConfigResponse,
	TMavenirDatesFilter,
	TMavenirVersionsFilter,
} from '@interfaces/cmModule/dataSources';
import {
	IMavenirConfigCreateDTO,
	IMavenirConfigsDTO,
	TMavenirConfigGroupOperationDTO,
	TMavenirConfigsCreateDTO,
} from '@interfaces/cmModule/dto/dataSourceDTO';

export const getMavenirConfigs = (params: IMavenirConfigsDTO): Promise<TMavenirConfigResponse> => {
	return client.get(`${URL.mavenirConfig}`, { params });
};

export const getMavenirConfig = (id: string): Promise<IMavenirConfig> => {
	return client.get(`${URL.mavenirConfig}/${id}`);
};

export const createMavenirConfig = (dto: IMavenirConfigCreateDTO): Promise<void> => {
	return client.post(`${URL.mavenirConfig}`, dto);
};

export const createMavenirConfigs = (dto: TMavenirConfigsCreateDTO[]): Promise<void> => {
	return client.post(`${URL.mavenirConfigs}`, dto);
};

export const deleteMavenirConfig = (id: string): Promise<void> => {
	return client.post(`${URL.mavenirConfig}/${id}/delete`, {});
};

export const deleteMavenirConfigs = (dto: TMavenirConfigGroupOperationDTO): Promise<void> => {
	return client.post(`${URL.mavenirConfig}/delete`, dto);
};

export const exportMavenirConfigs = (dto: TMavenirConfigGroupOperationDTO): Promise<void> => {
	return client.post(`${URL.mavenirConfig}/export`, dto);
};

export const exportMavenirConfig = (id: string): Promise<void> => {
	return client.post(`${URL.mavenirConfig}/${id}/export`, {});
};

export const downloadMavenirConfig = (id: string): Promise<void> => {
	return client.get(`${URL.mavenirConfig}/${id}/download`);
};

export const viewMavenirConfig = (id: string): Promise<IMavenirConfigTree> => {
	return client.get(`${URL.mavenirConfig}/${id}/view`);
};

export const uploadMavenirConfig = (fileName: string): Promise<IMavenirConfigUploadUrl> => {
	return client.post(`${URL.mavenirConfig}/create-upload-url`, { fileName });
};

export const getMavenirConfigVersions = (): Promise<TMavenirVersionsFilter> => {
	return client.get(`${URL.mavenirConfig}/versions`);
};

export const getMavenirConfigTypes = (): Promise<string[]> => {
	return client.get(`${URL.mavenirConfig}/types`);
};

export const getMavenirConfigGNBIds = (): Promise<string[]> => {
	return client.get(`${URL.mavenirConfig}/gnb-ids`);
};

export const getMavenirConfigIds = (): Promise<string[]> => {
	return client.get(`${URL.mavenirConfig}/config-ids`);
};

export const getMavenirConfigDates = (): Promise<TMavenirDatesFilter> => {
	return client.get(`${URL.mavenirConfig}/dates`);
};

export const checkMavenirConfigIsExist = (dto: IMavenirConfigCheck): Promise<string[]> => {
	return client.post(`${URL.mavenirConfig}/get-file-names-exist`, dto);
};
